import React from "react";

const Footer = () => {
  return (
    <section
      id="footer"
      className="w-full flex justify-center py-20 border-b-[1px] border-b-black"
    >
      <p>&copy; 2024. All rights reserved by Makuochukwu Okeke</p>
    </section>
  );
};

export default Footer;
